import { EventrDate } from '@eventr/common'
import { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { z } from 'zod'
import { ActivityValidationSchema } from '../activities/activityEditItem'
export const DateFieldsValidator = () => {
    const { control, setValue } = useFormContext<ActivityValidationSchema>()

    // Watch the relevant fields
    const dueBy = useWatch({ control, name: 'due_date' })
    const startBy = useWatch({ control, name: 'start_by' })
    const type = useWatch({ control, name: 'type' })

    useEffect(() => {
        // Skip validation for general items or if dates are missing
        if (type !== 'todo' || !dueBy || !startBy) return

        // Validate dates using Zod
        const dateValidator = z
            .object({
                dueBy: z.string(),
                startBy: z.string(),
            })
            .refine(
                (data) => {
                    try {
                        const dueBy = new EventrDate(data.dueBy).getUnixMs
                        const startBy = new EventrDate(data.startBy).getUnixMs
                        return startBy <= dueBy
                    } catch (e) {
                        console.warn('Date parsing error', e)
                        return true // Skip validation if dates can't be parsed
                    }
                },
                {
                    message: 'End date adjusted to match start date',
                    path: ['end'],
                }
            )

        // Run validation
        const result = dateValidator.safeParse({ dueBy, startBy })

        // If validation fails, adjust end date
        if (!result.success) {
            setValue('start_by', dueBy, {
                shouldValidate: true,
                shouldDirty: true,
            })
        }
    }, [dueBy, startBy, type, setValue])

    // This component doesn't render anything
    return null
}
